import React from 'react'

import app from '../../../app.jsx'
import DialogTeamSelect from '../../team/dialog_team_select/dialog_team_select.jsx'

const PageLogin = () => {
  const teams = app.isLoggedIn ? app.availableTeams : null
  const activeTeam = app.isLoggedIn ? app.activeTeam : null

  const onTeamSelect = (teamId) => {
    return app.authentication.afterLogin(app.user, teamId).then(() => {
      return app.redirect('/')
    })
  }

  if (activeTeam) {
    app.redirect('/')

    return null
  }

  return (
    <div className='page-team-select'>
      {teams && (
        <DialogTeamSelect
          teams={teams}
          onSelect={onTeamSelect}
        />
      )}
    </div>
  )
}

export default PageLogin
